export default {
  // Disabled 'no global assign' linting rule for this file but please check Wimpie or Nico if self needs to be reassigned as it is a read only global varible that should not modified
  /* eslint-disable no-global-assign */
  data() {
    return {
      faceBookLoading: false,
      googleLoading: false,
      appleLoading: false,
      userType: 'contact',
    };
  },
  methods: {

    /* --------------GOOGLE LOGIN RELATED METHODS-----------------------*/
    loginWithGoogle(mode) {
      this.userType = mode === 'leadbooker' ? 'contact' : 'cosignin';
      this.showGoogleLoading();
      this.initGoogle().then((auth) => {
        self = this;
        if (auth.isSignedIn.get() === false) {
          auth.signIn().then((googleUser) => {
            // console.log('user signed in');
            self.handleGoogleAuthResponse(googleUser);
          }).catch((error) => {
            // console.log('user failed to login');
          }).then(() => { this.googleLoading = false; });
        }
        else if (auth.isSignedIn.get() === true) {
          // console.log('user already signed in');
          self.handleGoogleAuthResponse(auth.currentUser.get());
        }
      });
    },
    handleGoogleAuthResponse(currrentUser) {
      const authResponse = { accessToken: currrentUser.getAuthResponse().access_token, idToken: currrentUser.getAuthResponse().id_token, userType: this.userType };
      this.$store.dispatch('users/logInByGoogleAuthResponse', authResponse).then((res) => {
        // logged in - now the login template will be replaced by the current template in app.vue
        this.$emit('usersigned', res.contact.id);
      }).catch((error) => {
        // error occured with login attempt
        console.log(error);
      }).then(() => { this.googleLoading = false; });
    },
    initGoogle() {
      return new Promise((resolve, reject) => {
        this.loadGoogleSDK().then(() => {
          gapi.load('auth2', () => {
            // https://developers.google.com/identity/sign-in/web/reference#gapiauth2clientconfig
            const auth2 = gapi.auth2.init({
              client_id: process.env.VUE_APP_GOOGLE_CLIENTID,
              cookiepolicy: 'single_host_origin',
              scope: 'profile',
            });
            resolve(auth2);
          });
        });
      });
    },
    async loadGoogleSDK() {
      await new Promise((api_ready) => document.head.append(Object.assign(
        document.createElement('script'),
        {
          src: 'https://apis.google.com/js/api.js',
          onload: api_ready,
        },
      )));
    },
    showGoogleLoading() {
      this.googleLoading = true;
      self = this;
      setTimeout(() => { self.googleLoading = false; }, 3000);
    },
    /*-----------------------------------------------------------------*/

    /* -------------FACEBOOK LOGIN RELATED METHODS--------------------*/
    logInWithFacebook(mode) {
      this.userType = mode === 'leadbooker' ? 'contact' : 'cosignin';
      this.showFBLoading();
      this.launchFBLogin();
    },
    launchFBLogin() {
      // https://developers.facebook.com/docs/reference/javascript/FB.getLoginStatus
      // check current login status
      self = this;
      // launch FB login Popup
      window.FB.login((response) => {
        if (response.authResponse) {
          self.handleFaceBookAuthResponse(response.authResponse);
        } else {
          // console.log('User cancelled login or did not fully authorize.');
          self.faceBookLoading = false;
        }
      }, { scope: 'email', return_scopes: true });
    },
    handleFaceBookAuthResponse(authResponse) {
      const authResponseData = { accessToken: authResponse.accessToken, userID: authResponse.userID, userType: this.userType };
      this.$store.dispatch('users/logInByFBAuthResponse', authResponseData).then((res) => {
        // logged in - now the login template will be replaced by the current template in app.vue
        this.$emit('usersigned', res.contact.id);
      }).catch((error) => {
        console.log(error);
      }).then(() => { this.faceBookLoading = false; });
    },
    initFacebook() {
      return new Promise((resolve, reject) => {
        this.loadFacebookSDK().then(() => {
          window.fbAsyncInit = function () {
            window.FB.init({
              appId: process.env.VUE_APP_FACEBOOK_APPID, // You will need to change this
              cookie: true, // This is important, it's not enabled by default
              xfbml: true,
              version: 'v9.0',
            });
            resolve();
          };
        });
      });
    },
    async loadFacebookSDK() {
      await new Promise((api_ready) => document.head.append(Object.assign(
        document.createElement('script'),
        {
          src: 'https://connect.facebook.net/en_US/sdk.js',
          onload: api_ready,
        },
      )));
    },
    showFBLoading() {
      this.faceBookLoading = true;
      self = this;
      setTimeout(() => { self.faceBookLoading = false; }, 3000);
    },

    /*-----------------------------------------------------------------*/

    /* --------------APPLE LOGIN RELATED METHODS-----------------------*/
    logInWithApple(mode) {
      this.userType = mode === 'leadbooker' ? 'contact' : 'cosignin';
      this.showAppleLoading();
      this.initApple().then((auth) => {
        AppleID.auth.signIn().then((res) => {
          this.handleAppleAuthResponse(res);
        }).catch((error) => {
          this.appleLoading = false;
          // console.log(error);
        });
      });
    },
    handleAppleAuthResponse(authResponse) {
      authResponse.userType = this.userType;
      // console.log(authResponse);
      this.$store.dispatch('users/logInByAppleAuthResponse', authResponse).then((res) => {
        // logged in - now the login template will be replaced by the current template in app.vue
        this.$emit('usersigned', res.contact.id);
      }).catch((error) => {
        // console.log(error);
      }).then(() => { this.appleLoading = false; });
    },
    initApple() {
      return new Promise((resolve, reject) => {
        if (typeof AppleID === 'undefined') {
          this.loadAppleSDK().then(() => {
            AppleID.auth.init({
              clientId: process.env.VUE_APP_APPLE_CLIENTID,
              redirectURI: `${process.env.VUE_APP_URL}/secure`,
              scope: 'email name',
              usePopup: true,
            });
            resolve();
          });
        }
        else {
          resolve();
        }
      });
    },
    async loadAppleSDK() {
      await new Promise((apple_api_ready) => document.head.append(Object.assign(
        document.createElement('script'),
        {
          src: 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
          onload: apple_api_ready,
        },
      )));
    },
    showAppleLoading() {
      this.appleLoading = true;
      self = this;
      setTimeout(() => { self.appleLoading = false; }, 3000);
    },
    /*-----------------------------------------------------------------*/
  },
};
